export default __webpack_public_path__ + "static/media/education.e88720e1.png";